<template>
  <div class="text-left">
    <div v-if="componentReady">
      <h5 v-text="t('forms.new_contractor_services.IC_0001')"/>
      <hr>

      <div class="panel">
        <p>
          <span v-text="t('forms.new_contractor_services.IC_0002')"/>
          <span class="required">*</span>
        </p>
      </div>

      <div class="row">
        <div class="small-12 medium-5 columns">
          <h6 v-text="t('forms.new_contractor_services.IC_0003')"/>

          <div>
            <input
              v-model="availableText"
              type="text"
              :placeholder="t('register.filter_service')">
          </div>

          <select v-model="employerFilterId" v-if="serviceData.employerServices.length > 0">
            <option
              value="0"
              v-text="t('forms.browse_contractor_top.IC_0019')"/>
            <option
              v-for="service in serviceData.employerServices"
              :value="service.EmployerID"
              v-text="service.Name"/>
          </select>

          <select
            v-model="availableServices"
            multiple
            @dblclick="addToSelected"
            size="15">
            <option
              v-for="service in availableList"
              :value="service.ID"
              :title="service.Text"
              v-text="service.Text"/>
          </select>

        </div>

        <div class="small-12 medium-2 columns text-center show-for-medium-up">
          <div>
            <div style="top: 220px; position: relative;">
              <a
                class="fa fa-angle-double-left fa-2x grow"
                @click="removeFromSelected"/>
              <a
                class="fa fa-angle-double-right fa-2x grow"
                @click="addToSelected"/>
            </div>
          </div>
        </div>

        <div class="small-12 medium-2 columns text-center show-for-small-only">
          <div>
            <div style="position: relative;">
              <a
                class="fa fa-angle-double-up fa-2x grow"
                @click="removeFromSelected"/>
              <a
                class="fa fa-angle-double-down fa-2x grow"
                @click="addToSelected"/>
            </div>
          </div>
        </div>

        <div class="small-12 medium-5 columns">
          <h6 v-text="t('forms.new_contractor_services.IC_0004')"/>

          <div>
            <input
              v-model="selectedText"
              type="text"
              :placeholder="t('register.filter_service')">
          </div>

          <select
            v-model="selectedServices"
            multiple
            @dblclick="removeFromSelected"
            size="15"
            :class="{marginTop45: serviceData.employerServices.length > 0}"
            >
            <option
              v-for="service in selectedList"
              :value="service.ID"
              :title="service.Text"
              v-text="service.Text"/>
          </select>
        </div>

      </div>

      <div class="row" style="margin-top: 30px;">
        <div class="columns large-3">
          <button
            class="tiny radius expand"
            @click="$emit('tab-change', 1)"
            v-text="t('courses.modal_previous')"/>
        </div>
        <div class="columns large-1">
          &nbsp;
        </div>
        <div class="columns large-4">
          <button
            @click="openGuide"
            class="tiny radius expand"
            v-text="t('register.user_guide')"/>
        </div>
        <div class="columns large-1">
          &nbsp;
        </div>
        <div class="columns large-3">
          <button
            class="tiny radius expand"
            @click="nextStep"
            v-text="t('member_basic_edit.IC_0013')"/>
        </div>
      </div>
    </div>

    <div v-if="!componentReady">
      <i class="fa fa-spinner fa-spin fa-2x"/>
    </div>

  </div>

</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {

  props: ['displayData'],

  data() {
    return {
      localData: {},
      serviceData: {},
      originalServiceData: {},
      componentReady: false,
      availableServices: [],
      selectedServices: [],
      availableText: '',
      selectedText: '',
      employerFilterId: '0',
      emptySelection: false,
      availableList: [],
      selectedList: [],
    };
  },

  watch: {
    availableText(val) {
      this.reloadList();
    },

    selectedText(val) {
      this.reloadList();
    },

    employerFilterId(val) {
      if (val !== '0') {
        const employerService = _.find(this.serviceData.employerServices, service =>
          service.EmployerID === val);

        const serviceArray = employerService.Services;

        this.serviceData.servicesInfo =
          _.filter(_.cloneDeep(this.serviceData.servicesInfo), service =>
            _.includes(serviceArray, service.ID));
      } else {
        this.serviceData.servicesInfo = _.cloneDeep(this.originalServiceData.servicesInfo);
      }
    },

    'serviceData.servicesInfo': {
      deep: true,
      handler: function(val) {
        let match = _.filter(val, (info) => {
          return info.Selected === true;
        });

        this.emptySelection = _.size(match) === 0;
      }
    },
  },

  beforeMount() {
    this.localData = _.cloneDeep(this.displayData);

    $.post('/register/tab-data/service', (data) => {
      this.serviceData = data;
      this.originalServiceData = _.cloneDeep(data);
      this.componentReady = true;

      this.availableList = _.filter(_.cloneDeep(this.serviceData.servicesInfo), service =>
        service.Selected === false);

      this.selectedList = _.filter(_.cloneDeep(this.serviceData.servicesInfo), service =>
        service.Selected === true);
    }).fail( () => {
      window.location.href = '/register';
    });
  },

  methods: {
    openGuide() {
      window.open(t('register.user_guide_link'), '_blank')
    },

    nextStep() {
      if (this.emptySelection) {
        toastr.error(t('forms.new_contractor_services.IC_0002'));
      } else {
        this.$emit('display-change', this.localData);
        this.$emit('tab-change', 3);
      }
    },

    reloadList() {
      this.availableList =
        _.filter(_.cloneDeep(this.serviceData.servicesInfo), service =>
          _.includes(_.toLower(_.trim(service.Text)), _.toLower(_.trim(this.availableText)))
          && service.Selected === false );

      this.selectedList =
        _.filter(_.cloneDeep(this.serviceData.servicesInfo), service =>
          _.includes(_.toLower(_.trim(service.Text)), _.toLower(_.trim(this.selectedText)))
          && service.Selected === true );
    },

    saveService() {
      this.reloadList();

      let newServices = [];

      _.forEach(this.serviceData.servicesInfo, service => {
        if (service.Selected) {
          newServices.push(service.ID);
        }
      });

      newServices = newServices.join(',');

      this.localData.memberInfo.SearchService = newServices;

      $.post('/register/save-company', {
        memberInfo: this.localData.memberInfo,
      });
    },

    removeFromSelected() {
      _.forEach(this.serviceData.servicesInfo, service => {
        if (_.includes(this.selectedServices, service.ID)) {
          service.Selected = false;
        }
      });

      _.forEach(this.originalServiceData.servicesInfo, service => {
        if (_.includes(this.selectedServices, service.ID)) {
          service.Selected = false;
        }
      });

      this.saveService();

      return false;
    },

    addToSelected() {
      _.forEach(this.serviceData.servicesInfo, service => {
        if (_.includes(this.availableServices, service.ID)) {
          service.Selected = true;
        }
      });

      _.forEach(this.originalServiceData.servicesInfo, service => {
        if (_.includes(this.availableServices, service.ID)) {
          service.Selected = true;
        }
      });

      this.saveService();

      return false;
    },
  },
};
</script>
<style scoped>
.grow:hover {
  -webkit-transform: scale(1.3);
  -ms-transform: scale(1.3);
  transform: scale(1.3);
}
.marginTop45 {
  margin-top: 45px;
}
</style>
